import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuItems, Modules, SubMenues } from 'src/app/appCommon/Enums/enum';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss'],
})
export class SideBarComponent implements OnInit {

  items!: MenuItem[];
  url: string = '';
  urlHref: string = '';
  roleAccessResult:any = [];
  isAccessToDefine: boolean = false;
  isAccessToPiTeam:boolean = false;
  isAccessToRoleAssignment: boolean = false;
  isAccessToUsers: boolean = false;
  isAccessToFacilityBenchmarks: boolean = false;
  isAccessToFacilitySpecs: boolean = false;
  isAccessToStandardProcess: boolean = false;
  isAccessToMeasure: boolean = false;
  isAccessToCaseFollowUp: boolean = false;
  isAccessToAnalyze: boolean = false;
  isAccessToFacilityPI: boolean = false;
  isAccessToRCA: boolean = false;
  isAccessToImprove: boolean = false;
  isAccessToDefault: boolean = false;
  isAccessToControl: boolean = false;
  isAccessToAdmin: boolean = false;
  isAccessToQMSReports: boolean = false;
  isAccessToStrokeQualityMetrics: boolean = false;
  isAccessToMRS: boolean = false;
  isAccessToSetting: boolean = false;
  isAccessToRCATree: boolean = false;
  isAccessToRapidITrending: boolean = false;
  [key: string]: any;

  constructor(private router: Router, public PiTeamService: PiteamService,
    private helperService: HelperService,
    private Observable:ObservableService) {
    this.url = Modules.Layout;
  }

  ngOnInit(): void {
  const menuItemsAccess:any = {
  [MenuItems.Define]: 'isAccessToDefine',
  [MenuItems.PiTeam]: 'isAccessToPiTeam',
  [MenuItems.RolesAssignment]: 'isAccessToRoleAssignment',
  [MenuItems.QMSUsers]: 'isAccessToUsers',
  [MenuItems.FacilityBenchmarks]: 'isAccessToFacilityBenchmarks',
  [MenuItems.FacilitySpecs]: 'isAccessToFacilitySpecs',
  [MenuItems.StandardProcess]: 'isAccessToStandardProcess',
  [MenuItems.Measure]: 'isAccessToMeasure',
  [MenuItems.CaseFollowUp]: 'isAccessToCaseFollowUp',
  [MenuItems.Analyze]: 'isAccessToAnalyze',
  [MenuItems.FacilityPI]: 'isAccessToFacilityPI',
  [MenuItems.RCA]: 'isAccessToRCA',
  [MenuItems.Improve]: 'isAccessToImprove',
  [MenuItems.PIReports]: 'isAccessToDefault',
  [MenuItems.RCATree]: 'isAccessToRCATree',
  [MenuItems.Control]: 'isAccessToControl',
  [MenuItems.QMSReports]: 'isAccessToQMSReports',
  [MenuItems.RapidiTrending]: 'isAccessToRapidITrending',
  [MenuItems.StrokeQualityMetrics]: 'isAccessToStrokeQualityMetrics',
  [MenuItems.MRS]: 'isAccessToMRS',
  [MenuItems.Admin]: 'isAccessToAdmin',
  [MenuItems.Setting]: 'isAccessToSetting',
};
     this.roleAccessResult = JSON.parse(this.helperService.decryption(localStorage.getItem('roleAccessResult')));
     this.roleAccessResult.forEach((item: any) => {
      const menuItemAccessProperty = menuItemsAccess[item.com_page_title];
      if (menuItemAccessProperty && item.cac_isAllowed) {
        this[menuItemAccessProperty] = true;
      }
    });
    this.isAccessToAdmin = this.isAccessToRCATree && this.isAccessToSetting;
     
    this.items = [
      {
        
        label: 'Define',
        icon: 'define-icon side-icons',
        styleClass: 'custom-design',
        visible: this.isAccessToDefine,
        items: [
          {
            label: 'PI Team',
            icon: 'pt-team child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToPiTeam,
            items: [
              {
                label: 'Roles Assignment',
                icon: 'assignRole child-icons',
                styleClass: 'child-custom-design',
                visible:this.isAccessToRoleAssignment,
                command: e => this.changeRouter(this.Routes('Roles Assignment')),
              },
              {
                label: 'Users',
                icon: 'addUser child-icons',
                styleClass: 'child-custom-design',
                visible:this.isAccessToUsers,
                command: e => this.changeRouter(this.Routes('Users')),
              }
            ]
          },
          {
            label: 'Facility Benchmarks',
            icon: 'facility-goals child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToFacilityBenchmarks,
            command: e => this.changeRouter(this.Routes('Facility Benchmarks'))
          },
          {
            label: 'Facility Specifics',
            icon: 'facility-specs child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToFacilitySpecs,
            command: e => this.changeRouter(this.Routes('Facility Specifics'))
          },
          {
            label: 'Standard Process',
            icon: 'standard-process child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToStandardProcess,
            command: e => this.changeRouter(this.Routes('Standard Process'))
          },
        ],
      },
      {
        label: 'Measure',
        icon: 'measure-icon side-icons',
        styleClass: 'custom-design',
        visible: this.isAccessToMeasure,
        items: [
          {
            label: 'Case Follow Up',
            icon: 'analyzeCase child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToCaseFollowUp,
            command: e => this.changeRouter(this.Routes('Case Follow Up'))
          },
        ],
      },
      {
        label: 'Analyze',
        icon: 'analyze-icon side-icons',
        styleClass: 'custom-design abc',
        visible:this.isAccessToAnalyze,
        items: [
          {
            label: 'Facility-PI',
            icon: 'FacilityPI child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToFacilityPI,
            command: e => this.changeRouter(this.Routes('Facility-PI'))
          },
          {
            label: 'RCA',
            icon: 'analyzeCase child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToRCA,
            command: e => this.changeRouter(this.Routes('RCA'))
          },
        ],
      },
      {
        label: 'Improve',
        icon: 'improve-icon side-icons',
        styleClass: 'custom-design',
        visible:this.isAccessToImprove,
        items: [
          {
            label: 'PI Reports',
            icon: 'improve-icon1 child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToDefault,
            command: e => this.changeRouter(this.Routes('PI Reports'))
          },
        ],
      },

      {
        label: 'Control',
        icon: 'control-icon side-icons',
        styleClass: 'custom-design',
        visible:this.isAccessToControl,
        items: [
          {
            label: 'Reports',
            icon: 'control-icon-report child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToQMSReports,
            items: [
              {
                label: 'Stroke Quality Metrics',
                icon: 'control-icon-sqm child-icons',
                styleClass: 'child-custom-design',
                visible: this.isAccessToStrokeQualityMetrics,
                command: e => this.changeRouter(this.Routes('Stroke Quality Metrics')),
              },
              {
                label: '90 Day MRS',
                icon: 'control-icon-mrs child-icons',
                styleClass: 'child-custom-design',
                visible: this.isAccessToMRS,
                command: e => this.changeRouter(this.Routes('MRS')),
              }
            ]
          },
          {
            label: 'RAPIDi Trending',
            icon: 'rapidi-trending-icon-report child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToRapidITrending,
            command: e => this.changeRouter(this.Routes('Rapidi Trending'))
          },
        ]
      },
      {
        label: 'Admin',
        icon: 'settings side-icons',
        styleClass: 'custom-design',
        visible:this.isAccessToAdmin && !environment.production,
        items: [
          {
            label: 'Setting',
            icon: 'settingAnalyze child-icons',
            styleClass: 'child-custom-design',
            visible:this.isAccessToSetting,
            items: [
              {
                label: 'Error Console',
                icon: 'FacilityPI child-icons',
                styleClass: 'child-custom-design',
                visible:this.isAccessToRCATree,
                command: e => this.changeRouter(this.Routes('Error Console')),
              }
            // items: [
            //   {
            //     label: 'RCA-Tree',
            //     icon: 'FacilityPI child-icons',
            //     styleClass: 'child-custom-design',
            //     visible:this.isAccessToRCATree,
            //     command: e => this.changeRouter(this.Routes('RCA-Tree')),
            //   },
            ]
          },
        ]
      },
    ]
  }
  
  ngAfterViewInit() {
    let menu = window.location.href.includes('Define')? 'Define': window.location.href.includes('Measure')? 'Measure': window.location.href.includes('Analyze')? 'Analyze': window.location.href.includes('Improve')? 'Improve': window.location.href.includes('Administration')? 'Admin' : window.location.href.includes('Control') ? 'Control' : '';
    if (menu) {
      this.activeMenu('', menu);
    }
  }
  
  changeRouter(value: any) {
    if (value == "/Home/Define/Users") {
      if (this.router.url == `/${Modules.Layout}/${Modules.Define}/${SubMenues.CreateUsers}`) {
        this.PiTeamService._createUsersComponent.SideNavLoggedUser();
      } else {
        this.router.navigate([value]);
        this.Observable.value$.next(false);
      }
    }
    else {
      this.router.navigate([value]);
      this.Observable.value$.next(false);
    }
    localStorage.removeItem('editUserId');
  }

  activeMenu(event: any, type:any) {
    if(type == 'menu'){
    let node;
    var menuText = event.target.innerText.replaceAll(' ','').toLowerCase();
    if (event.target.classList.contains("p-submenu-header") == true || Object.values(SubMenues).includes(menuText) || menuText == 'rca' || menuText == 'casefollowup' || menuText == 'pireports' || menuText == 'facilityspecifics' || menuText == 'piteam' || menuText == 'facilitybenchmarks' || menuText == 'standardprocess' || menuText == 'facility-pi' || menuText == 'rolesassignment' || menuText == 'users' || menuText == 'errorconsole' || menuText == 'setting' ||  menuText == 'strokequalitymetrics' ||  menuText == '90daymrs') {
      node = "submenu";
    }
    else if (event.target.tagName === "SPAN") {
      node = event.target.parentNode.parentNode;
    } else {
      node = event.target.parentNode;
    }
    if (node != "submenu") {
      let menuitem = document.getElementsByClassName("p-menuitem");
      for (let i = 0; i < menuitem.length; i++) {
        menuitem[i].classList.remove("active");
      }
      node.classList.add("active");
    }
  }else{
    const menuItems:any = document.getElementsByClassName("p-menuitem");
    for (let i = 0; i < menuItems.length; i++) {
      if (menuItems[i].innerText.includes(type)) {
        menuItems[i].classList.add("active");
      }
    }
  }
  }
   
  showMenu(event:any) {
    let label: any = event.target.innerText || event.target.parentElement.innerText || '';
    if(label != 'Define' && label != 'PI Team' && label != 'Measure' && label != 'Analyze' && 
    label != 'Improve' && label != 'Control' && label != 'Admin' && label != 'Setting' && label != 'Reports'){
      let selectedItem:any;
      if(label === "90 Day MRS"){
        label = "MRS";
      }
      selectedItem = this.Routes(label);
       this.urlHref = this.router.serializeUrl(this.router.createUrlTree([selectedItem]));
    }else{
      // this.urlHref = window.location.href;
      event.preventDefault();
    }
  }

  Routes(value:string){
    let selectedItem:any;
    switch(value)
    {
      case 'Roles Assignment': selectedItem = `/${Modules.Layout}/${Modules.Define}/${SubMenues.CreateRoles}`;break;
      case 'Users': selectedItem = `/${Modules.Layout}/${Modules.Define}/${SubMenues.CreateUsers}`;break;
      case 'Facility Benchmarks': selectedItem = `/${Modules.Layout}/${Modules.Define}/${SubMenues.Facilities}`;break;
      case 'Facility Specifics': selectedItem = `/${Modules.Layout}/${Modules.Define}/${SubMenues.FacilitySpecs}`;break;
      case 'Standard Process': selectedItem = `/${Modules.Layout}/${Modules.Define}/${SubMenues.StandardProcess}`;break;
      case 'Case Follow Up': selectedItem = `/${Modules.Layout}/${Modules.Measures}/${Modules.Measures}`;break;
      case 'Facility-PI': selectedItem = `/${Modules.Layout}/${Modules.Analyze}/${SubMenues.FacilityPI}`;break;
      case 'RCA': selectedItem = `/${Modules.Layout}/${Modules.Analyze}/${SubMenues.Cases}`;break;
      case 'PI Reports': selectedItem = `/${Modules.Layout}/${Modules.Improve}/${SubMenues.Default}`;break;
      case 'RCA-Tree': selectedItem = `/${Modules.Layout}/${Modules.SettingsModule}/${SubMenues.RCATree}`;break;
      case 'Stroke Quality Metrics': selectedItem = `/${Modules.Layout}/${Modules.Control}/${SubMenues.StrokeQualityMetrics}`;break;
      case 'MRS': selectedItem = `/${Modules.Layout}/${Modules.Control}/${SubMenues.MRS}`;break;
      case 'Error Console': selectedItem = `/${Modules.Layout}/${Modules.SettingsModule}/${SubMenues.ElmahError}`;break;
      case 'Rapidi Trending': selectedItem = `/${Modules.Layout}/Control/${SubMenues.RapidiTrending}`;break;
    }
    return selectedItem;
  }

}
